// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3iugj","dragIcon":"Choice_dragIcon__2JfGq","left":"Choice_left__jq_FV","input":"Choice_input__TQBBH"};